import { TRESPONSE_PROCESS_LISTING } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableRowNode } from '../../table.type';

export const PROCESS_LISTING_TABLE_MODEL = {
  createModel: (processes: TRESPONSE_PROCESS_LISTING['processes']) => {
    return ModifiersZTableModel.createTableModel(
      processes,
      {
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'Process Name',
            widthInPx: 150,
          },
          { type: 'TEXT_CELL', text: 'Process ID', widthInPx: 150 },
          {
            type: 'TEXT_CELL',
            text: 'Department',
            widthInPx: 150,
          },
          {
            type: 'TEXT_CELL',
            text: 'UOM',
            widthInPx: 150,
            liftedInput: {
              input: { type: 'INPUT', subType: 'text' },
              metadata: { keyName: '', isRequired: false },
            },
          },
          {
            type: 'TEXT_CELL',
            text: 'Factory - Day Capacity',
          },
        ],
        edit: {
          hasAddRow: false,
          hasDeleteRow: true,
          disableEdit: true,
        },
      },
      (item): TTableRowNode<TRESPONSE_PROCESS_LISTING['processes'][number]> => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            { type: 'TEXT_CELL', text: item.processName },
            { type: 'TEXT_CELL', text: item.userProcessId },
            { type: 'TEXT_CELL', text: item.department },
            { type: 'TEXT_CELL', text: item.uom },
            {
              type: 'TEXT_LIST_CELL',
              text: item.factoryInfoToDayCapacities.map((ftc) => `${ftc.factory.factoryName} - ${ftc.dayCapacity}`),
              orientation: 'VERTICAL',
            },
          ],
        };
      },
    );
  },
};
